import React from 'react';
import './index.css';
import ReactDOM from "react-dom";
import reportWebVitals from './reportWebVitals';
import Screens from './screens';

require("./analytics");

ReactDOM.render(
  <React.StrictMode>
    <Screens />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
